// import axios from "axios";
import jwt_decode from "jwt-decode";
import { DefaultAPIInstance } from "@/api";
import { AuthAPI } from "@/api/AuthAPI";

// const auth_url = 'token/';
// const refresh_token_url = 'token/refresh/';
// const reg_url = 'users/';
// const recovery_pass_url = 'users/password-reset-email/';
// const recovery_pass_complate_url ='users/password-reset-complete/';

export const authorizationModule = {
    state: () => ({
        accessToken: localStorage.getItem('access-token') || '',
        userId: '',
    }),
    getters: {
        isAuthenticated: state => !!state.accessToken,
        getUserId: state => state.userId,
    },
    mutations: {
        setMessageId(state, id) {
            state.messageId = id
        },
        authSuccess(state) {
            let accessToken = localStorage.getItem('access-token')
            if (accessToken) {
              let decoded = jwt_decode(accessToken);
              state.accessToken = accessToken
              state.userId = decoded.user_id
              localStorage.setItem('userId', decoded.user_id) 
              DefaultAPIInstance.defaults.headers.common['Authorization'] = accessToken
            }
        },
        authError(state) {
            localStorage.removeItem('access-token') 
            localStorage.removeItem('refresh-token') 
            localStorage.removeItem('userId') 
            localStorage.removeItem('is-staff') 
            state.accessToken = ''
            state.userId = ''
            delete DefaultAPIInstance.defaults.headers.common['Authorization']
        },
    },
    actions: {
        async registration({ commit }, user) {
            return await AuthAPI.registration(user)
              .then((response) => {
                return response.status
              })
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4') && errorStatus !== 400){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return error.response;
              });
        },
        async login({ commit }, user) {
          return await AuthAPI.login(user)
              .then((response) => {
                const {access, refresh} = response.data
                localStorage.setItem('access-token', `Bearer ${access}`) 
                localStorage.setItem('refresh-token', refresh) 
                commit("authSuccess")
                return response.status;
              })
              .catch((error) => {
                commit("authError")
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4') && errorStatus !== 401){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return error.response.data;
              });
        },
        async loginVerification({ commit }, token) {
          return await AuthAPI.verification(token)
              .then((response) => {
                return response.status;
              })
              .catch((error) => {
                let errorStatus = error.response.status
                return errorStatus;
              });
        },
        // async updateToken({ commit, dispatch }) {
        //     // return await axios
        //     //     .post(refresh_token_url, {"refresh": localStorage.getItem('refresh-token')})
        //     //     .then((response) => {                
        //     //         commit("authSuccess", response.data.access)
        //     //         return response.status;
        //     //     })
        //     //     .catch(error => {
        //     //         dispatch("logout")
        //     //         return error
        //     //     })

        //       return  await fetch(refresh_token_url, {
        //           method: 'POST',
        //           headers: {
        //             'Content-Type': 'application/json;charset=utf-8'
        //           },
        //           body: JSON.stringify({"refresh": localStorage.getItem('refresh-token')})
        //         })
        //         .then(response => response.json())
        //         .then(response => {
        //           commit("authSuccess", response.access)
        //         })
        //         .then(() => "success")
        //         .catch(error => {
        //           dispatch("logout")
        //           return error
        //         })

        // },
        logout({commit, rootState}) {
            return new Promise((resolve, reject) => {
                commit("authError")
                for (let key in rootState.profile.profileData) {
                  delete rootState.profile.profileData[key];
                }
                for (let key in rootState.personaldata.personalData) {
                  delete rootState.personaldata.personalData[key];
                }
                resolve()
            })
        },
        async recoveryPassword({commit}, emailData){
          return await AuthAPI.recoveryPassword(emailData)
              .then((response) => {
                return response.status;
              })
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4') && errorStatus !== 404){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true }) 
                }
                
                return errorStatus;
              });
        },
        async recoveryPasswordPhone({commit}, phoneData){
          return await AuthAPI.recoveryPasswordPhone(phoneData)
              .then((response) => {
                return response.status;
              })
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4') && errorStatus !== 404){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true }) 
                }
                
                return errorStatus;
              });
        },
        async resetComplatePassword({commit}, passData){
          return await AuthAPI.resetComplatePassword(passData)
              .then((response) => {
                return response.status;
              })
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4')){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return errorStatus;
              });
        },
        async sendActivateMessage({commit}, idClient) {
          return await AuthAPI.sendActivateMessage(idClient)
              .then((response) => {
                return response.status;
              })
              .catch((error) => {
                return error.response.status;
              });
        },
    },
    namespaced: true
}